'use strict';
(function () {
  if (!customElements.get('pb-popup')) {
    class PbPopup extends HTMLElement {
      constructor() {
        super();
        this.closeModal = this.closeModal.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onOverlayClick = this.onOverlayClick.bind(this);
        this.onOpenBtnClick = this.onOpenBtnClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this); // Keydown handler
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }
    }

    PbPopup.prototype.setupElements = function() {
      this.openBtn = this.querySelector('[data-component="open-btn"]');

      this.modal = this.querySelector('[data-component="modal"]');
      this.overlay = this.querySelector('[data-component="overlay"]');
      this.close = this.querySelector('[data-component="close"]');
      
      // Ensure the buttons are focusable
      if (this.openBtn) this.openBtn.setAttribute('tabindex', '0');
      if (this.close) this.close.setAttribute('tabindex', '0');
    };

    PbPopup.prototype.addEventListeners = function() {
			this.addEventListener('click', this.onClick)
      if (this.openBtn) {
        this.openBtn.addEventListener('click', this.onOpenBtnClick);
        this.openBtn.addEventListener('keydown', this.onKeyDown); // Add keydown event for openBtn
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', this.onOverlayClick);
      }
      if (this.close) {
        this.close.addEventListener('click', this.onOverlayClick);
        this.close.addEventListener('keydown', this.onKeyDown); // Add keydown event for close
      }
    };

    PbPopup.prototype.removeEventListeners = function() {
			this.removeEventListener('click', this.onClick)
      if (this.openBtn) {
        this.openBtn.removeEventListener('click', this.onOpenBtnClick);
        this.openBtn.removeEventListener('keydown', this.onKeyDown);
      }
      if (this.overlay) {
        this.overlay.removeEventListener('click', this.onOverlayClick);
      }
      if (this.close) {
        this.close.removeEventListener('click', this.onOverlayClick);
        this.close.removeEventListener('keydown', this.onKeyDown);
      }
    };

		PbPopup.prototype.onClick = function(e) {
			e.stopImmediatePropagation();
		};

    PbPopup.prototype.onOverlayClick = function(e) {
			e.stopImmediatePropagation();
      this.closeModal();
    };

    PbPopup.prototype.onOpenBtnClick = function(e) {
			e.stopImmediatePropagation();
      this.showModal();
    };

    // Handle keyboard navigation (Tab, Enter, Space)
    PbPopup.prototype.onKeyDown = function(e) {
      // Check if Tab key, Enter key, or Space key is pressed
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); // Prevent default action for Enter/Space
        if (e.target === this.openBtn) {
          this.showModal(); // Open the modal when pressing Enter/Space on the open button
        } else if (e.target === this.close) {
          this.closeModal(); // Close the modal when pressing Enter/Space on the close button
        }
      }
    };

    PbPopup.prototype.showModal = function() {
      if (!this.modal) return;
      this.modal.showModal();
    };

    PbPopup.prototype.closeModal = function() {
      if (!this.modal) return;
      this.modal.close();
    };

    customElements.define('pb-popup', PbPopup);
  }
})();